import { render } from "./App.vue?vue&type=template&id=af949a96"
const script = {}

import "./App.vue?vue&type=style&index=0&id=af949a96&lang=scss"
script.render = render

export default script